<template>
  <div>
    <!-- 商品类目 -->
    <el-dialog title="品牌类目" :visible.sync="pinpaiCategory" width="500px" @close="handleDialogClose">
      <div><el-checkbox v-model="isIndeterminate" @change="allCheck"></el-checkbox> 全选</div>
      <div class="tree-box">
        <el-tree
          :data="list"
          show-checkbox
          default-expand-all
          node-key="brandCd"
          ref="pinTree"
          highlight-current
          :props="defaultProps"
          :default-checked-keys="checkedClass"
          @check-change="handleCheckChange"
        ></el-tree>
      </div>
      <div class="classTotal">
        已添加 <span :style="{ color: globalBG }">{{ checkedList.length }}</span> 个类目
      </div>
      <div style="text-align:right" class="btn-group">
        <el-button @click="handleDialogClose">取消</el-button>
        <el-button @click="handleDialogSure" type="primary">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBrandList } from "@/api/analysis/ware-controller";
import { mapState } from "vuex";
export default {
  name: "",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    brandsList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
  },
  data() {
    return {
      pinpaiCategory: false,
      checkedClass: [],
      defaultProps: {
        children: "children",
        label: "barndnameFull",
      },
      isIndeterminate: false,
      list: [],
      checkedList: [],
    };
  },
  methods: {
    allCheck(val) {
      if (val) {
        let arr = this.list.map((i) => i.brandCd);
        this.$nextTick(() => {
          this.isIndeterminate = true;
          this.$refs.pinTree.setCheckedKeys(arr); //"treeList"是你自己在树形控件上设置的 ref="treeList" 的名称
        });
      } else {
        this.isIndeterminate = false;
        this.$refs.pinTree.setCheckedKeys([]); //"treeList"是你自己在树形控件上设置的 ref="treeList" 的名称
      }
    },
    handleDialogClose(value) {
      this.$emit("on-close", false);
    },
    handleDialogSure() {
      let data = this.checkedList.map((i) => i.brandCd);
      if (data.length == 0) {
        return this.$message.warning("请选择品牌");
      }
      this.$emit("on-close", true, data);
    },
    handleCheckChange(data, checked, indeterminate) {
      if (checked) {
        this.checkedList.push(data);
        if (this.checkedList.length == this.list.length) {
          this.isIndeterminate = true;
        } else {
          this.isIndeterminate = false;
        }
      } else {
        let index = this.checkedList.indexOf(data);
        this.checkedList.splice(index, 1);
        if (this.checkedList.length == this.list.length) {
          this.isIndeterminate = true;
        } else {
          this.isIndeterminate = false;
        }
      }
      // console.log(this.checkedList);
    },
  },
  async mounted() {
    const { data: res } = await getBrandList();
    this.list = res;
  },
  watch: {
    value(value) {
      // console.log(value, 11111111);
      this.pinpaiCategory = value;
      if (value == true) {
        let arr = [];
        if (this.brandsList.length != 0) {
          arr = this.brandsList.map((i) => i.brandCd);
        }
        this.$nextTick(() => {
          this.$refs.pinTree.setCheckedKeys(arr); //"treeList"是你自己在树形控件上设置的 ref="treeList" 的名称
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.classTotal {
  background: #f4f4f4;
  padding: 8px;
}
.tree-box {
  max-height: 300px;
  overflow: auto;
}
.btn-group {
  text-align: right;
  .el-button {
    width: 96px;
  }
}
</style>
